import React, { useRef } from 'react';
import styled from 'styled-components';

import EmailEditor from 'react-email-editor';
import sample from './sample.json';
import axios from 'axios';


const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`;

const Bar = styled.div`
  flex: 1;
  background-color: #61dafb;
  color: #000;
  padding: 10px;
  display: flex;
  max-height: 40px;

  h1 {
    flex: 1;
    font-size: 16px;
    text-align: left;
  }

  button {
    flex: 1;
    padding: 10px;
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
    background-color: #000;
    color: #fff;
    border: 0px;
    max-width: 150px;
    cursor: pointer;
  }
`;

const Example = (props) => {
  const emailEditorRef = useRef(null);

  const saveDesign = () => {
    emailEditorRef.current.editor.saveDesign((design) => {
      console.log(design);
      // Set design data
      localStorage.setItem('design', JSON.stringify(design));
      //alert('Design JSON has been logged in your developer console.');
    });
  };

  const exportHtml = () => {
    emailEditorRef.current.editor.exportHtml((data) => {
      const { design, html } = data;
      //console.log(html);
      localStorage.setItem('design', JSON.stringify(design));
      localStorage.setItem('html', html);
      //alert('Output HTML has been logged in your developer console.');
    });
  };

  const onDesignLoad = (data) => {
    console.log('onDesignLoad', data);
  };

  const onLoad = () => {
    console.log('onLoad');

    emailEditorRef.current.editor.addEventListener(
      'design:loaded',
      onDesignLoad
    );

    const params = new URLSearchParams(window.location.href)

    // You can access specific parameters:
    if(params.get('id')){
      axios.get( 'https://' + window.location.hostname + '/wp-json/automail/v1/template?id=' + params.get('id'))
        .then(function (response){
          const template = JSON.parse(response.data[0].template);
          localStorage.setItem('design', response.data[0].template);
          localStorage.setItem('html', response.data[0].html);
          emailEditorRef.current.editor.loadDesign(template);
        })
        .catch(err => console.log(err));
    }else{
      emailEditorRef.current.editor.loadDesign(sample);
    }

  }

  const onReady = () => {
    console.log('onReady');
  };

  const changeTemplate = () => {
    console.log('changeTemplate');
    var user_template = localStorage.getItem("template");
      //console.log('https://' + window.location.hostname + '/wp-content/plugins/auto-mail/assets/template/' + user_template + '.json');

      let url = 'https://' + window.location.hostname + '/wp-content/uploads/auto-mail-template/' + user_template + '.json';
      fetch(url, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then(out =>
        emailEditorRef.current.editor.loadDesign(out))
      .catch(err => console.log(err));
  };


  return (
    <Container>
      <Bar>
        <h1>Email Editor</h1>
        <button id="auto-mail-change-template" onClick={changeTemplate}>Change Template</button>
        <button id="auto-mail-save-design" onClick={exportHtml}>Save Design</button>
        <button class="auto-mail-switch-sections" onClick={exportHtml}>Next</button>
      </Bar>

      <React.StrictMode>
        <EmailEditor ref={emailEditorRef} onLoad={onLoad} onReady={onReady} />
      </React.StrictMode>
    </Container>
  );
};

export default Example;
